// extracted by mini-css-extract-plugin
export default {"root":"_1b2U5"};